import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const questions = [
  "How would you rate your overall experience in the role, and how closely did the responsibilities align with the job description shared during the hiring process?",
  "How would you rate your interview experience (interviewer professionalism, structure, and clarity)?",
  "How easy was it to complete and submit the required documentation?",
  "How would you rate your overall pre-boarding experience?",

];

const FeedbackForm = ({userid}) => {
  const [ratings, setRatings] = useState(Array(questions.length).fill(0));
  const [hovered, setHovered] = useState(Array(questions.length).fill(null));
  const [descriptions, setDescriptions] = useState(Array(questions.length).fill(''));
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);

  // 👇 Example: Getting userId from localStorage
  // const userId = localStorage.getItem('userId');
const navigate = useNavigate();

  const handleRating = (index, value) => {
    const updated = [...ratings];
    updated[index] = value;
    setRatings(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!userid) {
      alert('User ID is missing. Please log in first.');
      return;
    }
  
    if (ratings.includes(0)) {
      alert("Please provide a rating for all questions.");
      return;
    }
    
    try {
      const res = await fetch('http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/feedback/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userid, ratings, descriptions, comment })
      });
  
      const data = await res.json();
  
      if (res.ok) {
        setSubmitted(true);
        alert("Feedback submitted successfully!");
        navigate("/EnteryCandidatePortel/thank-you");
      } else {
        alert(data.error || "Failed to submit feedback.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Something went wrong while submitting feedback.");
    }
  };
  

  if (submitted) {
    return (
      <div className="max-w-2xl mx-auto mt-16 text-center text-green-700 bg-green-100 py-4 px-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold">✅ Thank you for your feedback!</h3>
        <p>We appreciate your time and insights.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-8 bg-white shadow-xl rounded-2xl mt-10 border-green-400 border-2">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center border-b pb-4">
        Onboarding Feedback Form
      </h2>
      <form onSubmit={handleSubmit} className="space-y-8">
        {questions.map((question, idx) => (
          <div key={idx}>
            <label className="block text-sm font-medium text-gray-800 mb-3">
              {idx + 1}. {question}
            </label>
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  size={28}
                  className={`cursor-pointer transition duration-200 ${
                    star <= (hovered[idx] ?? ratings[idx])
                      ? 'text-yellow-400'
                      : 'text-gray-300'
                  }`}
                  onClick={() => handleRating(idx, star)}
                  onMouseEnter={() => {
                    const newHovered = [...hovered];
                    newHovered[idx] = star;
                    setHovered(newHovered);
                  }}
                  onMouseLeave={() => {
                    const newHovered = [...hovered];
                    newHovered[idx] = null;
                    setHovered(newHovered);
                  }}
                />
              ))}
            </div>

            {ratings[idx] > 0 && (
              <input
                type="text"
                className="mt-3 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Describe your rating ..."
                value={descriptions[idx]}
                onChange={(e) => {
                  const updated = [...descriptions];
                  updated[idx] = e.target.value;
                  setDescriptions(updated);
                }}
              />
            )}
          </div>
        ))}

        <div>
          <label className="block text-sm font-medium text-gray-800 mb-2">
          Do you have any suggestions to improve the pre-boarding process?
          </label>
          <textarea
            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            rows="4"
            placeholder="Write any additional comments here..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            required
          />
        </div>

        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-full transition duration-200 shadow-md"
          >
            Submit Feedback
          </button>
        </div>
      </form>
    </div>
  );
};

export default FeedbackForm;
